import useUserSettings from "../../user/userSettings/useUserSettings";
import useUserInfo from "../../user/useUserInfo";
/** Blur NSFW covers for the same audience as the rest of the app: signed-out users, and users with "blur NSFW" on. */
export default function useShouldBlurNsfwCover() {
    const { isAuthenticated } = useUserInfo();
    const { blurNSFW } = useUserSettings();
    return !isAuthenticated || Boolean(blurNSFW);
}
